import React, { useState, useEffect, Fragment, useCallback } from "react";
import localization from "assets/localization/localization";
import { STATUS } from "constants/statusConstant";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import {
  ArrowRight,
  Filter,
  fileIcon,
  viewIcon,
} from "assets/images/imageData";
import DocumentView from "components/sales/downloadDocView/documentView";
import DivLayout from "components/sales/divLayout/divLayout";
import AddressView from "components/sales/leadDetails/addressView/addressView";
import InventoryDetail from "./inventoryDetail/inventoryDetail";
import { handleFormatDate } from "constants/dateFormat/dateFormat";
import CardSection from 'components/sales/cardSection/cardSection';
import 'assets/css/info-tooltip.css';
import SoftwareInventoryDetail from "./SoftwareInventoryDetail/SoftwareInventoryDetail";
import TagsInventoryDetail from "./TagInventoryDetail/TagsInventoryDetail";
import { toast } from "react-toastify";
import ModalPop from "components/sales/modal/modal";
import AccordionItem from "components/sales/accordion/AccordionItem";
import useAccordion from "components/sales/accordion/useAccordion";

const PostsaleView = ({ details, renewContracts, clientBrd = null, modificationData, requiredDocuments, contractInvoicePreview, setIsLoading, leadTypeId = null }) => {

    const daysForPrint = [
        "",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ]

  const [teamId, setTeamId] = useState();
  const [capexInvoicePreviewLinks, setCapexInvoicePreviewLinks] = useState([]);
  const [isModalPreview, setIsModalPreview] = useState(false);
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  
  // Generic accordion management
  const { toggleAccordion, isAccordionOpen } = useAccordion();

  useEffect(() => {
    (async () => {
      if (leadTypeId !== null && leadTypeId !== undefined && leadTypeId !== '') {
        setTeamId(parseInt(leadTypeId, 10));
        return;
      }
      const team =
        (await JSON.parse(localStorage.getItem("viewDetail"))) &&
        JSON.parse(localStorage.getItem("viewDetail"))[0]?.lead_type_id;
      setTeamId(team);
    })();
  }, [leadTypeId]);

  // Handle Capex Invoice Preview
  const handleCapexInvoicePreview = useCallback(async () => {
    if (!details?.capex_invoicing_details || !details?.commercial?.id) {
      toast.error("Required data not available for preview");
      return;
    }

    const payload = {
      lead_id: parseInt(details.commercial.lead_id),
      comm_id: parseInt(details.commercial.id),
      capex_invoicing: {
        ...details.capex_invoicing_details
      }
    };

    setIsLoadingPreview(true);
    if (setIsLoading) setIsLoading(true);

    try {
      const response = await contractInvoicePreview(payload);
      
      if (response?.data?.invoices_preview) {
        setCapexInvoicePreviewLinks(response.data.invoices_preview);
        setIsModalPreview(true);
        toast.success("Invoice preview generated successfully!");
      } else {
        toast.error("No preview available");
      }
    } catch (error) {
      toast.error("Failed to generate invoice preview");
      console.error("Invoice preview error:", error);
    } finally {
      setIsLoadingPreview(false);
      if (setIsLoading) setIsLoading(false);
    }
  }, [details, contractInvoicePreview, setIsLoading]);

  const handlePreviewModalHide = useCallback(() => {
    setIsModalPreview(false);
  }, []);

  const renderMileStoneInvoiceItems = (invoice, invoiceIndex) => {
    const items = Array.isArray(invoice) ? invoice : Object.values(invoice);
  
    return items.map((item, itemIdx) => {
      const materialNames = item.materials.join('');
  
      return (
        <div key={itemIdx} className="mb-2">
          <div className="col-md-4">
            <span className="fw-bold me-2">
              {materialNames}
            </span>
          </div>
          <div className="col-md-4">
            <span className="text-muted">
              <strong>Amount: </strong> {`${item?.amount} %`}
            </span>
          </div>
          <div className="col-md-4">
            <span className="text-muted">
              <strong>Specification: </strong> {item?.description}
            </span>
          </div>
        </div>
      );
    });
  };

  const renderRetentionInvoiceItems = (invoice, invoiceIndex) => {
    const items = Array.isArray(invoice) ? invoice : Object.values(invoice);
    return items.map((item, itemIdx) => {
      return (
        <div key={itemIdx} className="mb-2">
          <div className="col-md-4">
            <span className="text-muted">
              <strong>Description: {`${item?.desc ? item.desc : localization.na}`}</strong>
            </span>
          </div>
          <div className="col-md-4">
            <span className="text-muted">
              <strong>Amount: </strong> {`${item?.percentage
                        ? item.percentage
                        : localization.na} %`}
            </span>
          </div>
          <div className="col-md-4">
            <span className="text-muted">
              <strong>Months: </strong> {`${item?.months
                        ? item.months
                        : localization.na} %`}
            </span>
          </div>
          <div className="col-md-4">
            <span className="text-muted">
              <strong>Stage: </strong> {item?.post_stage_value
                        ? item.post_stage_value
                        : localization.na}
            </span>
          </div>
        </div>
      );
    });
  };

  const renderSingleInvoiceItems = (invoice, invoiceIndex) => {
    const items = Array.isArray(invoice) ? invoice : Object.values(invoice);
  
    return items.map((item, itemIdx) => {
      const materialNames = item.materials?.map(
        (name) => `${name}`
      ).join('  ') || '—';
  
      return (
        <div key={itemIdx} className="mb-2">
          <div className="col-md-4">
            <span className="fw-bold me-2">
              Line {itemIdx + 1}:
            </span>
          </div>
          <div className="col-md-4">
            <span className="me-3">{materialNames}</span>
          </div>
          <div className="col-md-4">
            <span className="text-muted">
              <strong>Specification: </strong> {item?.description}
            </span>
          </div>
        </div>
      );
    });
  };

  return (
    <Fragment>
      <hr />
      <h3 className="panel-heading">{localization.postsaleData}</h3>
      {renewContracts &&
        renewContracts?.renew_contracts &&
        renewContracts?.renew_contracts.map((obj, index) => {
          return (
            <div
              className={`${
                index !== 0 ? "panel-card bg_style" : "panel-card"
              }`}
            >
              <div
                className={`${
                  index === 0
                    ? "panel-heading ongoing_contract"
                    : "panel-heading"
                }`}
              >
                {index === 0
                  ? localization.commercialType + " (Ongoing Contract)"
                  : localization.commercialType}
              </div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.commercialType}
                    data={
                      obj.commercial?.commercialName
                        ? obj.commercial.commercialName
                        : localization.na
                    }
                  />
                </div>
              </div>
              <div className="panel-heading">{localization.commercialDisc}</div>
              {/* {teamId === STATUS.CORPORATE && ( */}
              {
                <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={localization.totalAmount}
                      data={
                        obj.commercial?.total_mg_amount
                          ? obj.commercial.total_mg_amount
                          : localization.na
                      }
                    />

                    <Fragment>
                      <DivLayout
                        heading={localization.takeEtaxes}
                        data={
                          obj.commercial?.take_amount
                            ? obj.commercial.take_amount
                            : localization.na
                        }
                      />
                    </Fragment>
                    <Fragment>
                      <DivLayout
                        heading={localization.installationAmount}
                        data={
                          obj.commercial?.installation_amount
                            ? obj.commercial.installation_amount
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.subAmt}
                        data={
                          obj.commercial?.subscription_amount
                            ? obj.commercial.subscription_amount
                            : localization.na
                        }
                      />
                    </Fragment>
                    <Fragment>
                      <DivLayout
                        heading={localization.commission}
                        data={
                          obj.commercial?.mdr_percentage
                            ? obj.commercial.mdr_percentage + "%"
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.paymentTerms}
                        data={
                          obj.commercial?.payment_term
                            ? obj.commercial.payment_term
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.paymentTermsDesc}
                        data={
                          obj.commercial?.commercial_description
                            ? obj.commercial.commercial_description
                            : localization.na
                        }
                      />
                    </Fragment>
                    <Fragment>
                      <DivLayout
                        heading={localization.paymentMode}
                        data={
                          obj.commercial?.payment_mode
                            ? obj.commercial.payment_mode
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.totalContract}
                        data={
                          obj.commercial?.contract_length
                            ? obj.commercial.contract_length
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.LockIn}
                        data={
                          obj.commercial?.contract_lockin_period
                            ? obj.commercial.contract_lockin_period
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.yearlyInclin}
                        data={
                          obj.commercial?.yearly_inclination
                            ? obj.commercial.yearly_inclination
                            : localization.na
                        }
                      />
                      {obj.commercial &&
                      obj.commercial.scope_of_work &&
                      obj.commercial.scope_of_work === 1 ? (
                        <>
                          <DivLayout
                            heading={localization.scopeOfCivilWork}
                            data={"Client"}
                          />
                          {/*<DivLayout
                          heading={localization.type}
                          data={obj.commercial?.type_of_work
                            ? obj.commercial.type_of_work
                            : localization.na}
                        />*/}
                        </>
                      ) : null}
                      {obj.commercial &&
                      obj.commercial.scope_of_work &&
                      obj.commercial.scope_of_work === 2 ? (
                        <DivLayout
                          heading={localization.scopeOfCivilWork}
                          data={"Park+"}
                        />
                      ) : null}

                      <DivLayout
                        heading={localization.civilScope}
                        data={
                          obj.commercial?.civil_scope
                            ? obj.commercial.civil_scope == 1
                              ? "Client"
                              : "Park+"
                            : localization.na
                        }
                      />

                      <DivLayout
                        heading={localization.electricalScope}
                        data={
                          obj.commercial?.electric_scope
                            ? obj.commercial.electric_scope == 1
                              ? "Client"
                              : "Park+"
                            : localization.na
                        }
                      />

                      <DivLayout
                        heading={localization.installationCharge}
                        data={
                          obj.commercial?.installation_amount
                            ? obj.commercial.installation_amount
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.installationDeadline}
                        data={
                          obj.commercial?.installation_deadline
                            ? obj.commercial.installation_deadline
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.installationStartDate}
                        data={
                          obj.commercial?.installation_start_date
                            ? obj.commercial.installation_start_date
                            : localization.na
                        }
                      />

                      <DivLayout
                        heading={localization.securityDeposit}
                        data={
                          obj?.security_deposit
                            ? obj.security_deposit
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.fastag_integrable}
                        data={
                          obj.commercial?.fastag_integrable
                            ? obj.commercial.fastag_integrable
                            : localization.na
                        }
                      />

                      <DivLayout
                        heading={localization.opt_amount}
                        data={
                          obj.commercial?.opt_amount
                            ? obj.commercial.opt_amount
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.invoice_gen}
                        data={
                          obj.commercial?.invoice_gen
                            ? obj.commercial.invoice_gen
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={`Invoice Day (For Mid month Invoicing)`}
                        data={
                          obj.commercial?.pre_invoice_day
                            ? obj.commercial.pre_invoice_day
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.cartage_amount}
                        data={
                          obj.commercial?.cartage_amount
                            ? obj.commercial.cartage_amount
                            : localization.na
                        }
                      />
                      {obj.commercial?.rel_documents &&
                        obj.commercial?.rel_documents.map((obj, index) => {
                          return (
                            <>
                              <DocumentView
                                key={index + 1}
                                title={`${localization.image} ${index + 1}`}
                                attachment={obj}
                                showFullWidth={false}
                              />
                            </>
                          );
                        })}
                    </Fragment>
                  </div>
                </div>
              }
              <div className="panel-heading">{localization.manualInvoice}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={`Installation`}
                    data={
                      obj.commercial?.manual_invoice?.installation_check
                        ? obj.commercial.manual_invoice.installation_check
                        : "No"
                    }
                  />
                  <DivLayout
                    heading={`Tag`}
                    data={
                      obj.commercial?.manual_invoice?.tag_check
                        ? obj.commercial.manual_invoice.tag_check
                        : "No"
                    }
                  />
                  <DivLayout
                    heading={`Rental/Capex`}
                    data={
                      obj.commercial?.manual_invoice?.rental_check
                        ? obj.commercial.manual_invoice.rental_check
                        : "No"
                    }
                  />
                  <DivLayout
                    heading={`1st Invoice Number`}
                    data={
                      obj.commercial?.manual_invoice?.rental_invoice_number
                        ? obj.commercial.manual_invoice.rental_invoice_number
                        : "N/A"
                    }
                  />
                </div>
              </div>
              {teamId === STATUS.SUPPLY && (
                <div className="panel-body">
                  <div className="details-listing">
                    {obj.commercial?.commercial_type_id === 1 ||
                    obj.commercial?.commercial_type_id === 8 ||
                    obj.commercial?.commercial_type_id === 11 ||
                    obj.commercial?.commercial_type_id === 12 ? (
                      <Fragment>
                        <DivLayout
                          heading={localization.paymentTerm}
                          data={
                            obj.commercial?.payment_term
                              ? obj.commercial.payment_term
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.securityDeposit}
                          data={
                            obj?.security_deposit
                              ? obj.security_deposit
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.slots4MgCar}
                          data={
                            obj?.four_wheeler_slots_mg
                              ? obj.four_wheeler_slots_mg
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.slots2MgBike}
                          data={
                            obj?.two_wheeler_slots_mg
                              ? obj.two_wheeler_slots_mg
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.slotsRevenue4Car}
                          data={
                            obj?.four_wheeler_slots_revenue
                              ? obj.four_wheeler_slots_revenue
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.slotsRevenue2Bike}
                          data={
                            obj?.two_wheeler_slots_revenue
                              ? obj.two_wheeler_slots_revenue
                              : localization.na
                          }
                        />
                      </Fragment>
                    ) : null}
                    {obj.commercial?.commercial_type_id === 1 ||
                    obj.commercial?.commercial_type_id === 8 ? (
                      <DivLayout
                        heading={localization.costPerSlot}
                        data={
                          obj.commercial?.cost_per_slot
                            ? obj.commercial.cost_per_slot
                            : localization.na
                        }
                      />
                    ) : null}
                  </div>
                </div>
              )}
              {(teamId === STATUS.CORPORATE ||
                teamId === STATUS.APARTMENT ||
                teamId === STATUS.SUPPLY ||
                teamId === STATUS.WAREHOUSE) && (
                <Fragment>
                  {obj.contract_details?.contract_sign_date &&
                  (obj?.contract_type === 1 ||
                    obj?.contract_type === 3 ||
                    obj.contract_details?.contract_sign_date) ? (
                    <>
                      <div className="panel-heading">
                        {localization.agreementContract}
                      </div>
                      <div className="panel-body">
                        <div className="details-listing">
                          <DivLayout
                            heading={"Closure Date"}
                            data={
                              obj.contract_details?.contract_sign_date
                                ? obj.contract_details.contract_sign_date
                                : localization.na
                            }
                          />

                          {/* <DivLayout
                      heading={localization.agreementContractLength}
                      data={
                        obj.contract_details?.contract_period
                          ? details.contract_details.contract_period
                          : localization.na
                      }
                    /> */}
                          <DivLayout
                            heading={localization.agreementContractPeriodFrom}
                            data={`${obj.contract_details?.contract_from_date}`}
                          />
                          <DivLayout
                            heading={localization.agreementContractPeriodTo}
                            data={`${obj.contract_details?.contract_to_date}`}
                          />
                          {obj.contract_details &&
                          obj.contract_details?.contract_document ? (
                            <DocumentView
                              title={localization.attachmentAgreement}
                              attachment={
                                obj.contract_details?.contract_document
                              }
                            />
                          ) : null}
                        </div>
                      </div>
                    </>
                  ) : null}

                  {obj.po_details?.po_number &&
                  (obj?.commercial?.contract_type === 2 ||
                    obj?.commercial?.contract_type === 3 ||
                    obj?.commercial?.contract_type === 0) ? (
                    <>
                      <div className="panel-heading">
                        {localization.purchaseOrder}
                      </div>
                      <div className="panel-body">
                        <div className="details-listing">
                          <DivLayout
                            heading={localization.pONumber}
                            data={
                              obj.po_details?.po_number
                                ? obj.po_details.po_number
                                : localization.na
                            }
                          />
                          <DivLayout
                            heading={localization.pODate}
                            data={
                              obj.po_details?.po_date
                                ? obj.po_details.po_date
                                : localization.na
                            }
                          />
                          {obj.po_details && obj.po_details?.po_document ? (
                            <>
                              {Array.isArray(obj.po_details?.po_document) ? (
                                <>
                                  {obj.po_details?.po_document.map((val, i) => {
                                    return (
                                      <>
                                        <DocumentView
                                          title={localization.po}
                                          attachment={val}
                                        />
                                      </>
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  <DocumentView
                                    title={localization.po}
                                    attachment={obj.po_details?.po_document}
                                  />
                                </>
                              )}
                            </>
                          ) : null}
                        </div>
                      </div>
                    </>
                  ) : null}

                  {/* 
{obj.po_details?.po_number &&
                (obj?.commercial?.contract_type === 2 || obj?.commercial?.contract_type === 3 || obj?.commercial?.contract_type === 0) ? (
                  <>
                  <div className="panel-heading">
                      {localization.purchaseOrder}
                    </div>
                  <div className="panel-body">
                      <div className="details-listing">
                        {obj.po_details && obj.po_details?.client_brd ? (
                          <>
                            {Array.isArray(obj.po_details?.client_brd) ? (
                                <>
                                  {obj.po_details?.client_brd.map((val, i) => {

                                      return (
                                        <>
                                          <DocumentView
                                            title={localization.clientBrd}
                                            attachment={clientBrd}
                                          />
                                        </>
                                      )
                                    }
                                  )}
                                </>
                              ) :
                              <>
                                <DocumentView
                                  title={localization.clientBrd}
                                  attachment={clientBrd}
                                />
                              </>
                            }
                          </>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : null} */}

                  {obj.commercial?.commercial_type_id == 5 &&
                  (obj.milestone?.milestone_data ||
                    obj.milestone?.date_invoices_data ||
                    obj.milestone?.retention) ? (
                    <div className="panel-card">
                      <div className="panel-heading">
                        {localization.milestoneData}
                      </div>
                      <div className="panel-body">
                        <div className="details-listing">
                          <Fragment>
                            {obj && obj.milestone?.milestone_data ? (
                              <div className="w-100">
                                <AccordionItem
                                  title="Milestone Invoices"
                                  isOpen={isAccordionOpen('milestone', 1)}
                                  onToggle={() => toggleAccordion('milestone', 1)}
                                >
                                  {obj.milestone?.milestone_data.map(
                                    (obj, index) => {
                                      return (
                                        <div key={index}>
                                          <h5>Milestone {index + 1}</h5>
                                          <DivLayout
                                            heading={localization.stage}
                                            data={
                                              obj?.stage_name
                                                ? obj.stage_name
                                                : localization.na
                                            }
                                          />
                                          <DivLayout
                                            heading={localization.amount}
                                            data={
                                              obj?.amt
                                                ? obj.amt
                                                : localization.na
                                            }
                                          />
                                          <DivLayout
                                            heading={localization.lineItem}
                                            data={
                                              obj?.desc
                                                ? obj.desc
                                                : localization.na
                                            }
                                          />
                                          <DivLayout
                                            heading={
                                              localization.createInvoice
                                            }
                                            data={
                                              obj?.inv_creation_value
                                                ? obj.inv_creation_value
                                                : localization.na
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                  )}
                                </AccordionItem>
                              </div>
                            ) : null}
                            {obj && obj.milestone?.date_invoices_data ? (
                              <div className="w-100">
                                <AccordionItem
                                  title="Dated Invoices"
                                  isOpen={isAccordionOpen('milestone', 2)}
                                  onToggle={() => toggleAccordion('milestone', 2)}
                                >
                                  {obj.milestone?.date_invoices_data.map(
                                    (obj, index) => {
                                      return (
                                        <div key={index}>
                                              <h5>Invoice {index + 1}</h5>
                                              <DivLayout
                                                heading={localization.amount}
                                                data={
                                                  obj?.amt
                                                    ? obj.amt
                                                    : localization.na
                                                }
                                              />
                                              <DivLayout
                                                heading={localization.lineItem}
                                                data={
                                                  obj?.desc
                                                    ? obj.desc
                                                    : localization.na
                                                }
                                              />
                                              <DivLayout
                                                heading={
                                                  localization.invoiceDate
                                                }
                                                data={
                                                  obj?.inv_date
                                                    ? obj.inv_date
                                                    : localization.na
                                                }
                                              />
                                        </div>
                                      );
                                    }
                                  )}
                                </AccordionItem>
                              </div>
                            ) : null}
                            {obj && obj.milestone?.retention ? (
                              <div className="w-100">
                                <AccordionItem
                                  title="Retention Invoices"
                                  isOpen={isAccordionOpen('milestone', 3)}
                                  onToggle={() => toggleAccordion('milestone', 3)}
                                >
                                  {obj.milestone?.retention.map(
                                    (obj, index) => {
                                      return (
                                        <div key={index}>
                                          <h5>Invoice {index + 1}</h5>
                                          <DivLayout
                                            heading={localization.lineItem}
                                            data={
                                              obj?.desc
                                                ? obj.desc
                                                : localization.na
                                            }
                                          />
                                          <DivLayout
                                            heading={localization.amount}
                                            data={
                                              obj?.amt
                                                ? obj.amt
                                                : localization.na
                                            }
                                          />
                                          <DivLayout
                                            heading={
                                              localization.afterMonths
                                            }
                                            data={
                                              obj?.months
                                                ? obj.months
                                                : localization.na
                                            }
                                          />
                                          <DivLayout
                                            heading={
                                              localization.afterStage
                                            }
                                            data={
                                              obj?.post_stage_value
                                                ? obj.post_stage_value
                                                : localization.na
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                  )}
                                </AccordionItem>
                              </div>
                            ) : null}
                          </Fragment>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </Fragment>
              )}
            </div>
          );
        })}
      <div
        className={`${
          renewContracts && renewContracts?.is_renewed == 1
            ? "panel-card bg_style"
            : "panel-card"
        }`}
      >
        <div
          className={`${
            renewContracts && renewContracts?.is_renewed == 1
              ? "panel-heading"
              : "panel-heading ongoing_contract"
          }`}
        >
          {renewContracts && renewContracts?.is_renewed == 1
            ? localization.commercialType
            : localization.commercialType + " (Ongoing Contract)"}
        </div>
        <div className="panel-body">
          <div className="details-listing">
            <DivLayout
              heading={localization.commercialType}
              data={
                details.commercial?.commercialName
                  ? details.commercial.commercialName
                  : localization.na
              }
            />
          </div>
        </div>
        <div className="panel-heading">{localization.commercialDisc}</div>
        {/* {teamId === STATUS.CORPORATE && ( */}
        {
          <div className="panel-body">
            <div className="details-listing">

                <DivLayout
                    heading={localization.revenueNature}
                    data={
                        details.commercial?.revenue_nature
                            ? details.commercial.revenue_nature
                            : localization.na
                    }
                />
                <DivLayout
                    heading={localization.revenueType}
                    data={
                        details.commercial?.revenue_type
                            ? details.commercial.revenue_type
                            : localization.na
                    }
                />
                <DivLayout
                    heading={localization.revenueInvoiceType}
                    data={
                        details.commercial?.invoice_type
                            ? details.commercial.invoice_type
                            : localization.na
                    }
                />
              <DivLayout
                heading={localization.totalAmount}
                data={
                  details.commercial?.total_mg_amount
                    ? details.commercial.total_mg_amount
                    : localization.na
                }
              />

              <Fragment>
                <DivLayout
                  heading={localization.takeEtaxes}
                  data={
                    details.commercial?.take_amount
                      ? details.commercial.take_amount
                      : localization.na
                  }
                />
              </Fragment>
              <Fragment>
                <DivLayout
                  heading={localization.installationAmount}
                  data={
                    details.commercial?.installation_amount
                      ? details.commercial.installation_amount
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.subAmt}
                  data={
                    details.commercial?.subscription_amount
                      ? details.commercial.subscription_amount
                      : localization.na
                  }
                />
              </Fragment>
              <Fragment>
                <DivLayout
                  heading={localization.commission}
                  data={
                    details.commercial?.mdr_percentage
                      ? details.commercial.mdr_percentage + "%"
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.paymentTerms}
                  data={
                    details.commercial?.payment_term
                      ? details.commercial.payment_term
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.paymentTermsDesc}
                  data={
                    details.commercial?.commercial_description
                      ? details.commercial.commercial_description
                      : localization.na
                  }
                />
              </Fragment>
              <Fragment>
                <DivLayout
                  heading={localization.paymentMode}
                  data={
                    details.commercial?.payment_mode
                      ? details.commercial.payment_mode
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.paymentDueDays}
                  data={
                    details.commercial?.payment_due_days_name
                      ? details.commercial?.payment_due_days_name
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.solutionType}
                  data={
                    details.commercial?.solution_type_name
                      ? details.commercial?.solution_type_name
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.product}
                  data={
                    details?.product_details?.name
                      ? details?.product_details?.name
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.totalContract}
                  data={
                    details.commercial?.contract_length
                      ? details.commercial.contract_length
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.LockIn}
                  data={
                    details.commercial?.contract_lockin_period
                      ? details.commercial.contract_lockin_period
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.yearlyInclin}
                  data={
                    details.commercial?.yearly_inclination
                      ? details.commercial.yearly_inclination
                      : localization.na
                  }
                />
                {details.commercial &&
                details.commercial.scope_of_work &&
                details.commercial.scope_of_work === 1 ? (
                  <>
                    <DivLayout
                      heading={localization.scopeOfCivilWork}
                      data={"Client"}
                    />
                    {/*<DivLayout
                      heading={localization.type}
                      data={details.commercial?.type_of_work
                        ? details.commercial.type_of_work
                        : localization.na}
                    />*/}
                  </>
                ) : null}
                {details.commercial &&
                details.commercial.scope_of_work &&
                details.commercial.scope_of_work === 2 ? (
                  <DivLayout
                    heading={localization.scopeOfCivilWork}
                    data={"Park+"}
                  />
                ) : null}

                <DivLayout
                  heading={localization.civilScope}
                  data={
                    details.commercial?.civil_scope
                      ? details.commercial.civil_scope == 1
                        ? "Client"
                        : "Park+"
                      : localization.na
                  }
                />

                <DivLayout
                  heading={localization.electricalScope}
                  data={
                    details.commercial?.electric_scope
                      ? details.commercial.electric_scope == 1
                        ? "Client"
                        : "Park+"
                      : localization.na
                  }
                />

                <DivLayout
                  heading={localization.installationCharge}
                  data={
                    details.commercial?.installation_amount
                      ? details.commercial.installation_amount
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.installationDeadline}
                  data={
                    details.commercial?.installation_deadline
                      ? details.commercial.installation_deadline
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.installationStartDate}
                  data={
                    details.commercial?.installation_start_date
                      ? details.commercial.installation_start_date
                      : localization.na
                  }
                />

                <DivLayout
                  heading={localization.securityDeposit}
                  data={
                    details?.security_deposit
                      ? details.security_deposit
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.fastag_integrable}
                  data={
                    details.commercial?.fastag_integrable
                      ? details.commercial.fastag_integrable
                      : localization.na
                  }
                />

                <DivLayout
                  heading={localization.opt_amount}
                  data={
                    details.commercial?.opt_amount
                      ? details.commercial.opt_amount
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.invoice_gen}
                  data={
                    details.commercial?.invoice_gen
                      ? details.commercial.invoice_gen
                      : localization.na
                  }
                />
                <DivLayout
                  heading={`Invoice Day (For Mid month Invoicing)`}
                  data={
                    details.commercial?.pre_invoice_day
                      ? details.commercial.pre_invoice_day
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.builderRwa}
                  data={
                    details.commercial?.builder_type
                      ? details.commercial.builder_type
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.cartage_amount}
                  data={
                    details.commercial?.cartage_amount
                      ? details.commercial.cartage_amount
                      : localization.na
                  }
                />
                {/* {details.commercial?.wiring_scope && 
                   <DivLayout
                   heading={localization.wiringScopePark}
                   data={
                     details.commercial?.wiring_scope
                       ? details.commercial.wiring_scope
                       : localization.na
                   }
                 />
                } */}
                {details.commercial?.wiring_uom && 
                   <DivLayout
                   heading={`Wiring UOM`}
                   data={
                     details.commercial?.wiring_uom
                       ? details.commercial.wiring_uom
                       : localization.na
                   }
                 />
                }
                {details.commercial?.wiring_req_qty && 
                   <DivLayout
                   heading={`Wiring Qty`}
                   data={
                     details.commercial?.wiring_req_qty
                       ? details.commercial.wiring_req_qty
                       : localization.na
                   }
                 />
                }
                {details.commercial?.wiring_per_unit_price && 
                   <DivLayout
                   heading={`Wiring Unit Price`}
                   data={
                     details.commercial?.wiring_per_unit_price
                       ? details.commercial.wiring_per_unit_price
                       : localization.na
                   }
                 />
                }
                <DivLayout
                  heading={localization.channelPartnerName}
                  data={
                    details?.contract_details?.channel_partner_name
                      ? details?.contract_details?.channel_partner_name
                      : localization.na
                  }
                />

                {(details && details.commercial && details?.commercial?.channel_partner_id) && (
                  <DivLayout
                    heading={'Contract Price to end client'}
                    data={
                      details?.commercial?.cp_price
                        ? details?.commercial?.cp_price
                        : localization.na
                    }
                  />
                )}

                {details.commercial?.rel_documents &&
                  details.commercial?.rel_documents.map((obj, index) => {
                    return (
                      <>
                        <DocumentView
                          key={index + 1}
                          title={`${localization.image} ${index + 1}`}
                          attachment={obj}
                          showFullWidth={false}
                        />
                      </>
                    );
                  })}
              </Fragment>
            </div>
          </div>

        }
          {details.commercial?.valet_service !== undefined && details.commercial?.valet_service !== null &&
              Object.keys(details.commercial?.valet_service).length > 0 &&
            <>
                <div className="panel-heading">{localization.services}</div>
                <div className="panel-body">
                    <div className="details-listing">
                        <div className="w-100">
                            {
                                details.commercial?.valet_service.map((val, i) => {
                                    return (
                                        <AccordionItem
                                            key={i}
                                            title={`Service ${i+1}`}
                                            isOpen={isAccordionOpen('service', i)}
                                            onToggle={() => toggleAccordion('service', i)}
                                        >
                                            <h5>Service {i + 1}</h5>
                                            <div className="details-listing">
                                                            <DivLayout
                                                                heading={localization.name}
                                                                data={
                                                                    val?.services?.service_name
                                                                        ? val.services.service_name
                                                                        : localization.na
                                                                }
                                                            />
                                                            {/*<DivLayout*/}
                                                            {/*    heading={localization.description}*/}
                                                            {/*    data={*/}
                                                            {/*        val?.services?.description*/}
                                                            {/*            ? val.services.description*/}
                                                            {/*            : localization.na*/}
                                                            {/*    }*/}
                                                            {/*/>*/}
                                                            <DivLayout
                                                                heading={localization.unitPrice}
                                                                data={
                                                                    val?.unit_price
                                                                        ? val.unit_price
                                                                        : localization.na
                                                                }
                                                            />
                                                            <DivLayout
                                                                heading={localization.quantity}
                                                                data={
                                                                    val?.quantity
                                                                        ? val.quantity
                                                                        : localization.na
                                                                }
                                                            />

                                                            <DivLayout
                                                                heading={localization.totalAmount}
                                                                data={
                                                                    val?.total_price
                                                                        ? val.total_price
                                                                        : localization.na
                                                                }
                                                            />

                                                            <DivLayout
                                                                heading={localization.type}
                                                                data={
                                                                    val?.type
                                                                        ? val.type
                                                                        : localization.na
                                                                }
                                                            />
                                                            <DivLayout
                                                                heading={localization.serviceStartDay}
                                                                data={
                                                                    daysForPrint[val?.start_day]
                                                                        ? daysForPrint[val.start_day]
                                                                        : localization.na
                                                                }
                                                            />

                                                            <DivLayout
                                                                heading={localization.serviceEndDay}
                                                                data={
                                                                    daysForPrint[val?.end_day]
                                                                        ? daysForPrint[val.end_day]
                                                                        : localization.na
                                                                }
                                                            />


                                            </div>
                                        </AccordionItem>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </>
          }

{details.commercial?.consumable_items && details.commercial?.consumable_items?.length > 0 &&
          <>
          <div className="panel-heading">Consumeable Items</div>
          <div className="panel-body">
          {/* {details.commercial?.consumable_items && details.commercial?.consumable_items?.length > 0 &&
                details.commercial?.consumable_items.map((item, index) => {
                  return (
                    <CardSection title={`Item ${index + 1}`}>
                        <div className="details-listing">
                            <DivLayout
                                heading={'Name'}
                                data={item?.name}
                            />
                            <DivLayout
                                heading={'Make'}
                                data={item?.make}
                            />
                            <DivLayout
                                heading={'UOM'}
                                data={item?.uom}
                            />
                            {item?.uom === "OTHERS" && 
                              <DivLayout
                                heading={'Others'}
                                data={item?.uom_other}
                             />
                            }
                            <DivLayout
                                heading={'Sales Qty'}
                                data={item?.sales_qty}
                            />
                            <DivLayout
                                heading={'Operation Qty'}
                                data={item?.ops_qty}
                            />
                            <DivLayout
                                heading={'Base Unit Price'}
                                data={item?.base_unit_price}
                            />
                            <DivLayout
                                heading={'Sale Unit Price'}
                                data={item?.sale_unit_price}
                            />
                          </div>
                      </CardSection>    
                  );
            })} */}
            {details.commercial?.consumable_items && details.commercial?.consumable_items.length > 0 && (
            <table className="table w-full border-collapse border border-gray-300" style={{overflow: "scroll"}}>
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-gray-300 px-4 py-2">#</th>
                  <th className="border border-gray-300 px-4 py-2">Name</th>
                  <th className="border border-gray-300 px-4 py-2">UOM</th>
                  <th className="border border-gray-300 px-4 py-2">Sales Qty</th>
                  {/* <th className="border border-gray-300 px-4 py-2">Operation Qty</th> */}
                  <th className="border border-gray-300 px-4 py-2">Base Unit Price</th>
                  <th className="border border-gray-300 px-4 py-2">Sale Unit Price</th>
                </tr>
              </thead>
              <tbody>
                {details.commercial.consumable_items.map((item, index) => (
                  <tr key={index} className="border border-gray-300">
                    <td className="border border-gray-300 px-4 py-2">{index + 1}</td>
                    <td className="border border-gray-300 px-4 py-2">{item?.service_name}</td>
                    <td className="border border-gray-300 px-4 py-2">{item?.uom}</td>
                    <td className="border border-gray-300 px-4 py-2">{item?.sales_qty ?? 0}</td>
                    {/* <td className="border border-gray-300 px-4 py-2">{item?.ops_qty ?? 0}</td> */}
                    <td className="border border-gray-300 px-4 py-2">{item?.base_unit_price}</td>
                    <td className="border border-gray-300 px-4 py-2">{item?.sale_unit_price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          </div>
          </>
        }
        
        <div className="panel-heading">{localization.manualInvoice}</div>
        <div className="panel-body">
          <div className="details-listing">
            <DivLayout
              heading={`Installation`}
              data={
                details.commercial?.manual_invoice?.installation_check
                  ? details.commercial.manual_invoice.installation_check
                  : "No"
              }
            />
            <DivLayout
              heading={`Tag`}
              data={
                details.commercial?.manual_invoice?.tag_check
                  ? details.commercial.manual_invoice.tag_check
                  : "No"
              }
            />
            <DivLayout
              heading={`Rental/Capex`}
              data={
                details.commercial?.manual_invoice?.rental_check
                  ? details.commercial.manual_invoice.rental_check
                  : "No"
              }
            />
            <DivLayout
              heading={`1st Invoice Number`}
              data={
                details.commercial?.manual_invoice?.rental_invoice_number
                  ? details.commercial.manual_invoice.rental_invoice_number
                  : "N/A"
              }
            />
          </div>
        </div>
        {teamId === STATUS.SUPPLY && (
          <div className="panel-body">
            <div className="details-listing">
              {details.commercial?.commercial_type_id === 1 ||
              details.commercial?.commercial_type_id === 8 ||
              details.commercial?.commercial_type_id === 11 ||
              details.commercial?.commercial_type_id === 12 ? (
                <Fragment>
                  <DivLayout
                    heading={localization.paymentTerm}
                    data={
                      details.commercial?.payment_term
                        ? details.commercial.payment_term
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.securityDeposit}
                    data={
                      details?.security_deposit
                        ? details.security_deposit
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.slots4MgCar}
                    data={
                      details?.four_wheeler_slots_mg
                        ? details.four_wheeler_slots_mg
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.slots2MgBike}
                    data={
                      details?.two_wheeler_slots_mg
                        ? details.two_wheeler_slots_mg
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.slotsRevenue4Car}
                    data={
                      details?.four_wheeler_slots_revenue
                        ? details.four_wheeler_slots_revenue
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.slotsRevenue2Bike}
                    data={
                      details?.two_wheeler_slots_revenue
                        ? details.two_wheeler_slots_revenue
                        : localization.na
                    }
                  />
                </Fragment>
              ) : null}
              {details.commercial?.commercial_type_id === 1 ||
              details.commercial?.commercial_type_id === 8 ? (
                <DivLayout
                  heading={localization.costPerSlot}
                  data={
                    details.commercial?.cost_per_slot
                      ? details.commercial.cost_per_slot
                      : localization.na
                  }
                />
              ) : null}
              {/* {details.commercial?.commercial_type_id === 1 ||
              details.commercial?.commercial_type_id === 11 ? ( */}
              {/* <DivLayout
                  heading={localization.parkCommission}
                  data={
                    details?.park_commision
                      ? details.park_commision
                      : localization.na
                  }
                /> */}
              {/* ) : null} */}
            </div>
          </div>
        )}
        {(teamId === STATUS.CORPORATE ||
          teamId === STATUS.APARTMENT ||
          teamId === STATUS.SUPPLY ||
          teamId === STATUS.WAREHOUSE) && (
          <Fragment>
            {details.contract_details?.contract_sign_date &&
            (details?.contract_type === 1 ||
              details?.contract_type === 3 ||
              details.contract_details?.contract_sign_date) ? (
              <>
                <div className="panel-heading">
                  {localization.agreementContract}
                </div>
                <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={"Closure Date"}
                      data={
                        details.contract_details?.contract_sign_date
                          ? details.contract_details.contract_sign_date
                          : localization.na
                      }
                    />

                    {/* <DivLayout
                      heading={localization.agreementContractLength}
                      data={
                        details.contract_details?.contract_period
                          ? details.contract_details.contract_period
                          : localization.na
                      }
                    /> */}
                    <DivLayout
                      heading={localization.agreementContractPeriodFrom}
                      data={`${details.contract_details?.contract_from_date}`}
                    />
                    <DivLayout
                      heading={localization.agreementContractPeriodTo}
                      data={`${details.contract_details?.contract_to_date}`}
                    />
                    {details.contract_details &&
                    details.contract_details?.contract_document ? (
                      <DocumentView
                        title={localization.attachmentAgreement}
                        attachment={details.contract_details?.contract_document}
                      />
                    ) : null}
                  </div>
                </div>
              </>
            ) : null}

            <>
              <div className="panel-heading">{localization.typeOfSales}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={"Type Of Sales"}
                    data={
                      details.commercial?.type_of_sales
                        ? details.commercial.type_of_sales
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={"Channel Partner"}
                    data={
                      details.commercial?.channel_partner
                        ? details.commercial.channel_partner
                        : localization.na
                    }
                  />
                  {details.commercial?.other_cp_name !== null && (
                    <DivLayout
                      heading={"Others/Details"}
                      data={
                        details.commercial?.other_cp_name
                          ? details.commercial.other_cp_name
                          : localization.na
                      }
                    />
                  )}
                </div>
              </div>
            </>

            {details.po_details?.po_number &&
            (details?.contract_type === 2 ||
              details?.contract_type === 3 ||
              details?.contract_type === 0) ? (
              <div className="panel-card">
                <div className="panel-heading">
                  {localization.purchaseOrder}
                </div>
                <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={localization.pONumber}
                      data={
                        details.po_details?.po_number
                          ? details.po_details.po_number
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.pODate}
                      data={
                        details.po_details?.po_date
                          ? details.po_details.po_date
                          : localization.na
                      }
                    />
                    {details.po_details && details.po_details?.po_document ? (
                      <>
                        {Array.isArray(details.po_details?.po_document) ? (
                          <>
                            {details.po_details?.po_document.map((val, i) => {
                              return (
                                <>
                                  <DocumentView
                                    title={localization.po}
                                    attachment={val}
                                  />
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <DocumentView
                              title={localization.po}
                              attachment={details.po_details?.po_document}
                            />
                          </>
                        )}
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}

            {(!details.capex_invoicing_details ||
              (Array.isArray(details.capex_invoicing_details) && details.capex_invoicing_details.length == 0) ||
              (typeof details.capex_invoicing_details === 'object' &&
                !Array.isArray(details.capex_invoicing_details) &&
                Object.keys(details.capex_invoicing_details).length == 0)) &&
              details.commercial?.commercial_type_id == 5 &&
            (details.milestone?.milestone_data ||
              details.milestone?.date_invoices_data ||
              details.milestone?.retention) ? (
              <div className="panel-card">
                <div className="panel-heading">
                  {localization.milestoneData}
                </div>
                <div className="panel-body">
                  <div className="details-listing">
                    <Fragment>
                      {details && details.milestone?.milestone_data ? (
                        <div className="w-100">
                          <AccordionItem
                            title="Milestone Invoices"
                            isOpen={isAccordionOpen('detail-milestone', 1)}
                            onToggle={() => toggleAccordion('detail-milestone', 1)}
                          >
                            {details.milestone?.milestone_data.map(
                              (obj, index) => {
                                return (
                                  <div key={index}>
                                    <h5>Milestone {index + 1}</h5>
                                        <DivLayout
                                          heading={localization.stage}
                                          data={
                                            obj?.stage_name
                                              ? obj.stage_name
                                              : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.amount}
                                          data={
                                            obj?.amt ? obj.amt : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.lineItem}
                                          data={
                                            obj?.desc
                                              ? obj.desc
                                              : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.createInvoice}
                                          data={
                                            obj?.inv_creation_value
                                              ? obj.inv_creation_value
                                              :                                           localization.na
                                      }
                                    />
                                  </div>
                                );
                              }
                            )}
                          </AccordionItem>
                        </div>
                      ) : null}
                      {details && details.milestone?.date_invoices_data ? (
                        <div className="w-100">
                          <AccordionItem
                            title="Dated Invoices"
                            isOpen={isAccordionOpen('detail-milestone', 2)}
                            onToggle={() => toggleAccordion('detail-milestone', 2)}
                          >
                            {details.milestone?.date_invoices_data.map(
                              (obj, index) => {
                                return (
                                  <div key={index}>
                                        <h5>Invoice {index + 1}</h5>
                                        <DivLayout
                                          heading={localization.amount}
                                          data={
                                            obj?.amt ? obj.amt : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.lineItem}
                                          data={
                                            obj?.desc
                                              ? obj.desc
                                              : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.invoiceDate}
                                          data={
                                            obj?.inv_date
                                              ? obj.inv_date
                                              : localization.na
                                          }
                                        />
                                  </div>
                                );
                              }
                            )}
                          </AccordionItem>
                        </div>
                      ) : null}
                      {details && details.milestone?.retention ? (
                        <div className="w-100">
                          <AccordionItem
                            title="Retention Invoices"
                            isOpen={isAccordionOpen('detail-milestone', 3)}
                            onToggle={() => toggleAccordion('detail-milestone', 3)}
                          >
                            {details.milestone?.retention.map(
                              (obj, index) => {
                                return (
                                  <div key={index}>
                                        <h5>Invoice {index + 1}</h5>
                                        <DivLayout
                                          heading={localization.lineItem}
                                          data={
                                            obj?.desc
                                              ? obj.desc
                                              : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.amount}
                                          data={
                                            obj?.amt ? obj.amt : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.afterMonths}
                                          data={
                                            obj?.months
                                              ? obj.months
                                              : localization.na
                                          }
                                        />
                                        <DivLayout
                                          heading={localization.afterStage}
                                          data={
                                            obj?.post_stage_value
                                              ? obj.post_stage_value
                                              :                                             localization.na
                                        }
                                      />
                                  </div>
                                );
                              }
                            )}
                          </AccordionItem>
                        </div>
                      ) : null}
                    </Fragment>
                  </div>
                </div>
              </div>
            ) : null}
          </Fragment>
        )}
        {/*{teamId === STATUS.B2BALLIANCE && (
          <div className="panel-body">
            <div className="details-listing">
              <DivLayout
                heading={'Cost/Per Slot'}
                data={
                  details.commercial?.cost_per_slot
                    ? details.commercial.cost_per_slot
                    : localization.na
                }
              />
              <DivLayout
                heading={'No. of Slots'}
                data={
                  details.commercial?.no_of_slots
                    ? details.commercial.no_of_slots
                    : localization.na
                }
              />
              <DivLayout
                heading={'Location'}
                data={
                  details.commercial?.location
                    ? details.commercial.location
                    : localization.na
                }
              />
            </div>
          </div>
        )}*/}
      {/* </div>

      <div className="panel-card"> */}
        {(teamId === STATUS.CORPORATE ||
          teamId === STATUS.APARTMENT ||
          teamId === STATUS.SUPPLY ||
          teamId === STATUS.WAREHOUSE) && (
          <>
            {details && details.leads_poc && details.leads_poc.length ? (
              <Fragment>
                <div className="panel-heading">{localization.pocTitle}</div>
                <div className="panel-body">
                  <div className="details-listing">
                    <Fragment>
                      <div className="w-100">
                        {details &&
                          details.leads_poc &&
                          details.leads_poc.map((obj, index) => {
                            return (
                              <AccordionItem
                                key={index}
                                title={`POC ${index + 1} - ${obj?.pocName ? obj.pocName : ""}`}
                                isOpen={isAccordionOpen('poc', index)}
                                onToggle={() => toggleAccordion('poc', index)}
                              >
                                <div className="details-listing">
                                      <DivLayout
                                        heading={localization.POCName}
                                        data={
                                          obj?.pocName
                                            ? obj.pocName
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.POCDesignation}
                                        data={
                                          obj?.pocDesVal
                                            ? obj.pocDesVal
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.phoneNumber}
                                        data={
                                          obj?.number
                                            ? obj.number
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.emailAddress}
                                        data={
                                          obj?.email
                                            ? obj.email
                                            : localization.na
                                        }
                                      />
                                </div>
                              </AccordionItem>
                            );
                          })}
                      </div>
                    </Fragment>
                  </div>
                </div>
              </Fragment>
            ) : null}
            {details && details.gates_data && details.gates_data.length ? (
              <Fragment>
                <div className="panel-heading">{localization.gateDetails}</div>
                <div className="panel-body">
                  <div className="details-listing">
                    <Fragment>
                      <div className="w-100">
                        {details &&
                          details.gates_data &&
                          details.gates_data.map((obj, index) => {
                            return (
                              <AccordionItem
                                key={index}
                                title={`Solution ${index + 1}`}
                                isOpen={isAccordionOpen('gate', index)}
                                onToggle={() => toggleAccordion('gate', index)}
                              >
                                <div className="details-listing">
                                      <DivLayout
                                        heading={localization.currentSetup}
                                        data={
                                          obj?.gateName
                                            ? obj.gateName
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.usedFor}
                                        data={
                                          obj?.used_for
                                            ? obj.used_for
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.hardwareRemoved}
                                        data={
                                          obj?.any_hardware_removed
                                            ? obj.any_hardware_removed
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.hardwareDtl}
                                        data={
                                          obj?.hardware_details
                                            ? obj.hardware_details
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={
                                          localization.internetAvailabilty
                                        }
                                        data={
                                          obj?.internet_availability
                                            ? obj.internet_availability
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.timeline}
                                        data={
                                          obj?.timeline_internet
                                            ? obj.timeline_internet
                                            : localization.na
                                        }
                                      />
                                      <DivLayout
                                        heading={localization.gateAmount}
                                        data={
                                          obj?.gate_amount
                                            ? obj.gate_amount
                                            : localization.na
                                        }
                                      />
                                      {/* New Fields */}
                                      {obj?.amc ? (
                                        <DivLayout
                                          heading={localization.amc}
                                          data={
                                            obj?.amc ? obj.amc : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.amc_amount ? (
                                        <DivLayout
                                          heading={localization.amcAmount}
                                          data={
                                            obj?.amc_amount
                                              ? obj.amc_amount
                                              : localization.na
                                          }
                                        />
                                      ) : null}

                                      {obj?.installation_cost ? (
                                        <DivLayout
                                          heading={
                                            localization.installationCost
                                          }
                                          data={
                                            obj?.installation_cost
                                              ? obj.installation_cost
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.parking_slot ? (
                                        <DivLayout
                                          heading={localization.parkingSlot}
                                          data={
                                            obj?.parking_slot
                                              ? obj.parking_slot
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.basemment ? (
                                        <DivLayout
                                          heading={localization.basemment}
                                          data={
                                            obj?.basemment
                                              ? obj.basemment
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.carSlot ? (
                                        <DivLayout
                                          heading={localization.carSlot}
                                          data={
                                            obj?.carSlot
                                              ? obj.carSlot
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.bikeSlot ? (
                                        <DivLayout
                                          heading={localization.bikeSlot}
                                          data={
                                            obj?.bikeSlot
                                              ? obj.bikeSlot
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.vendorName ? (
                                        <DivLayout
                                          heading={localization.vendorName}
                                          data={
                                            obj?.vendorName
                                              ? obj.vendorName
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.sellingCar ? (
                                        <DivLayout
                                          heading={localization.sellingCar}
                                          data={
                                            obj?.sellingCar
                                              ? obj.sellingCar
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.purchaseCar ? (
                                        <DivLayout
                                          heading={localization.purchaseCar}
                                          data={
                                            obj?.purchaseCar
                                              ? obj.purchaseCar
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.purchaseBike ? (
                                        <DivLayout
                                          heading={localization.purchaseBike}
                                          data={
                                            obj?.purchaseBike
                                              ? obj.purchaseBike
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.sellingBike ? (
                                        <DivLayout
                                          heading={localization.sellingBike}
                                          data={
                                            obj?.sellingBike
                                              ? obj.sellingBike
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.valetDriver ? (
                                        <DivLayout
                                          heading={localization.valetDriver}
                                          data={
                                            obj?.valetDriver
                                              ? obj.valetDriver
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.valetSup ? (
                                        <DivLayout
                                          heading={localization.valetSup}
                                          data={
                                            obj?.valetSup
                                              ? obj.valetSup
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.damageLiability ? (
                                        <DivLayout
                                          heading={localization.damageLiability}
                                          data={
                                            obj?.damageLiability
                                              ? obj.damageLiability
                                              : localization.na
                                          }
                                        />
                                      ) : null}

                                      {obj?.premium ? (
                                        <DivLayout
                                          heading={localization.premium}
                                          data={
                                            obj?.premium
                                              ? obj.premium
                                              : localization.na
                                          }
                                        />
                                      ) : null}

                                      {obj?.softwareCost ? (
                                        <DivLayout
                                          heading={localization.software_cost}
                                          data={
                                            obj?.softwareCost
                                              ? obj.softwareCost
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.SWPaymentType ? (
                                        <DivLayout
                                          heading={localization.SWPaymentType}
                                          data={
                                            obj?.SWPaymentType
                                              ? obj.SWPaymentType
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.chargerType ? (
                                        <DivLayout
                                          heading={localization.charger_type}
                                          data={
                                            obj?.chargerType
                                              ? obj.chargerType
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.valetDriverCost ? (
                                        <DivLayout
                                          heading={
                                            localization.valet_driver_cost
                                          }
                                          data={
                                            obj?.valetDriverCost
                                              ? obj.valetDriverCost
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.valetSupCost ? (
                                        <DivLayout
                                          heading={localization.valet_sup_cost}
                                          data={
                                            obj?.valetSupCost
                                              ? obj.valetSupCost
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.valetAtt ? (
                                        <DivLayout
                                          heading={localization.valet_attendant}
                                          data={
                                            obj?.valetAtt
                                              ? obj.valetAtt
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.valetAttCost ? (
                                        <DivLayout
                                          heading={
                                            localization.valet_attendent_cost
                                          }
                                          data={
                                            obj?.valetAttCost
                                              ? obj.valetAttCost
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.managementFee ? (
                                        <DivLayout
                                          heading={localization.management_fee}
                                          data={
                                            obj?.managementFee
                                              ? obj.managementFee
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.miscellaneousCost ? (
                                        <DivLayout
                                          heading={
                                            localization.miscellaneous_cost
                                          }
                                          data={
                                            obj?.miscellaneousCost
                                              ? obj.miscellaneousCost
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.revenueShare ? (
                                        <DivLayout
                                          heading={localization.revenue_share}
                                          data={
                                            obj?.revenueShare
                                              ? obj.revenueShare
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.profit ? (
                                        <DivLayout
                                          heading={localization.profit_share}
                                          data={
                                            obj?.profit
                                              ? obj.profit
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.remark ? (
                                        <DivLayout
                                          heading={localization.remark}
                                          data={
                                            obj?.remark
                                              ? obj.remark
                                              : localization.na
                                          }
                                        />
                                      ) : null}
                                      {obj?.totalAmount ? (
                                        <DivLayout
                                          heading={localization.amount}
                                          data={
                                            obj?.totalAmount
                                              ? obj.totalAmount
                                              : localization.na
                                          }
                                        />
                                      ) : null}

                                      {/* End  */}

                                      {obj.gate_photo &&
                                        obj.gate_photo.length > 0 && (
                                          <h5 className="details-listing">
                                            {localization.photos}
                                          </h5>
                                        )}
                                      {obj.gate_photo &&
                                        obj.gate_photo.length > 0 &&
                                        obj.gate_photo.map((obj, index) => {
                                          return (
                                            <DocumentView
                                              key={index + 1}
                                              title={`${localization.image} ${
                                                index + 1
                                              }`}
                                              attachment={obj}
                                            />
                                          );
                                        })}
                                      {obj.video && obj.video.length > 0 && (
                                        <h5>{localization.videos}</h5>
                                      )}
                                      {obj.video &&
                                        obj.video.length > 0 &&
                                        obj.video.map((obj, index) => {
                                          return (
                                            <DocumentView
                                              key={index + 1}
                                              title={`${localization.video} ${
                                                index + 1
                                              }`}
                                              attachment={obj}
                                            />
                                          );
                                        })}
                                </div>
                              </AccordionItem>
                            );
                          })}
                      </div>
                    </Fragment>
                  </div>
                </div>
              </Fragment>
            ) : null}
          </>
        )}

        {teamId === STATUS.SUPPLY && (
          <>
            {/* <div className="panel-card">
              <div className="panel-heading">{localization.siteFeatureForm}</div>
              <div className="panel-body">
                <div className="details-listing">
                  {details.hotel_site_type_data &&
                    Object.keys(details.hotel_site_type_data).length !== 0 && (
                      <>
                        <DivLayout
                          heading={localization.valetAvaliable}
                          data={
                            details.hotel_site_type_data.valet[0]
                              ?.valet_availaible
                              ? details.hotel_site_type_data.valet[0]
                                  ?.valet_availaible
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.noOfValetDrivers}
                          data={
                            details.hotel_site_type_data.valet[0]
                              ?.no_of_valet_drivers
                              ? details.hotel_site_type_data.valet[0]
                                  ?.no_of_valet_drivers
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.noOfRestaurants}
                          data={
                            details.hotel_site_type_data?.no_of_restaurants
                              ? details.hotel_site_type_data.no_of_restaurants
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.keyRestaurants}
                          data={
                            details.hotel_site_type_data?.key_restaurants
                              ? details.hotel_site_type_data?.key_restaurants
                              : localization.na
                          }
                        />
                      </>
                    )}
                  {details.mall_site_type_data &&
                    Object.keys(details.mall_site_type_data).length !== 0 && (
                      <>
                        <DivLayout
                          heading={localization.cinema}
                          data={
                            details?.mall_site_type_data?.cinema[0]
                              ?.cinema_availaible
                              ? details.mall_site_type_data?.cinema[0]
                                  .cinema_availaible
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.corporatesWthIn}
                          data={
                            details.mall_site_type_data
                              ?.corporated_within_premises
                              ? details.mall_site_type_data
                                  .corporated_within_premises
                              : localization.na
                          }
                        />
                        <DivLayout
                          heading={localization.keyTenant}
                          data={
                            details.mall_site_type_data?.key_tenants
                              ? details.mall_site_type_data.key_tenants
                              : localization.na
                          }
                        />
                      </>
                    )}
                  <DivLayout
                    heading={localization.noOfParking}
                    data={
                      details?.total_no_of_parking_slot
                        ? details.total_no_of_parking_slot
                        : localization.na
                    }
                  />
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">{localization.laneDetailsTitle}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.laneEntry}
                    data={
                      details?.no_of_lanes_entry
                        ? details.no_of_lanes_entry
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.laneExit}
                    data={
                      details?.no_of_lanes_exit
                        ? details.no_of_lanes_exit
                        : localization.na
                    }
                  />
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">{localization.facilitiesTitle}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.corporateOffices}
                    data={
                      details?.corporate_offices_in_vicinity
                        ? details.corporate_offices_in_vicinity
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.restaurantsVicnity}
                    data={
                      details?.restaurants_in_vicinity
                        ? details.restaurants_in_vicinity
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.otherVicinity}
                    data={
                      details?.vicinity_other
                        ? details.vicinity_other
                        : localization.na
                    }
                  />
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">
                {localization.restaurantDetailsTitle}
              </div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.noOfRestaurantsChain}
                    data={
                      details.restaurant_site_type_data?.no_of_restaurants
                        ? details.restaurant_site_type_data.no_of_restaurants
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.weekdayOccupancy}
                    data={
                      details.occupancy?.weekday
                        ? details.occupancy.weekday
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.weekendOccupancy}
                    data={
                      details.occupancy?.weekend
                        ? details.occupancy.weekend
                        : localization.na
                    }
                  />
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">
                {localization.parkingDetailsTitle}
              </div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.parkingChargesType}
                    data={
                      details?.parking_type
                        ? details.parking_type
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.parkingManagementCompany}
                    data={
                      details?.parking_management_company
                        ? details.parking_management_company
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.parkingEquipmentManufacture}
                    data={
                      details?.parking_equipment_manufacturer
                        ? details.parking_equipment_manufacturer
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.slotSensor}
                    data={
                      details?.slot_sensor ? details.slot_sensor : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.stackParking}
                    data={
                      details?.stack_parking
                        ? details.stack_parking
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.parkingEquipmentRemark}
                    data={
                      details?.parking_equipment_remarks
                        ? details.parking_equipment_remarks
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.otherLocationPresent}
                    data={
                      details?.other_location_present
                        ? details.other_location_present
                        : localization.na
                    }
                  />
                </div>
              </div>
            </div> */}
          </>
        )}
        {teamId === STATUS.B2BALLIANCE && (
          <>
            <h3 className="panel-heading">{localization.presaleData}</h3>
            <div className="panel-card">
              <div className="panel-heading">{localization.valProp}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.valPropClient}
                    data={
                      details?.proposition_for_client
                        ? details.proposition_for_client
                        : localization.na
                    }
                  />
                  <div className="details-list">
                    <strong className="data-title">
                      {localization.valPropForUs}
                    </strong>
                    <span className="data-details">
                      {" "}
                      {details?.proposition_for_park_plus &&
                      details.proposition_for_park_plus.length > 0
                        ? details.proposition_for_park_plus.map(
                            (item, index) => {
                              return (
                                <p key={index + 1}>
                                  {Object.keys(item)} - {Object.values(item)}{" "}
                                </p>
                              );
                            }
                          )
                        : localization.na}{" "}
                    </span>
                  </div>
                  <DocumentView
                    title={localization.referenceDocument}
                    attachment={details && details.proposition_for_client_doc}
                  />
                </div>
              </div>
            </div>
            <div className="panel-card">
              <div className="panel-heading">{localization.otherDetail}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.appAvail}
                    data={
                      details?.app_available
                        ? details.app_available
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.cities}
                    data={
                      details?.no_of_cities
                        ? details.no_of_cities
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.scopeOfPartnership}
                    data={
                      details?.scope_of_partnership
                        ? details.scope_of_partnership.toString()
                        : localization.na
                    }
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {teamId !== STATUS.B2BALLIANCE && (
          <Fragment>
            <div className="panel-card">
              <div className="panel-heading">{localization.gstDetails}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.gstRegis}
                    data={
                      details.gst_details?.gst_registered
                        ? details.gst_details?.gst_registered === "2"
                          ? "No"
                          : "Yes"
                        : localization.na
                    }
                  />
                  {details.gst_details?.gst_registered === "1" ? (
                    <DivLayout
                      heading={localization.gstNumberHead}
                      data={
                        details.gst_details?.gst_number
                          ? details.gst_details.gst_number
                          : localization.na
                      }
                    />
                  ) : details.gst_details &&
                    details.gst_details?.upload_non_gst_disclosure_form ? (
                    <DocumentView
                      title={localization.nonGSTDisclosureForm}
                      attachment={
                        details.gst_details?.upload_non_gst_disclosure_form
                      }
                    />
                  ) : null}
                  {details.gst_details && details.gst_details?.gst_document ? (
                    <DocumentView
                      title={localization.gstDetails}
                      attachment={details.gst_details?.gst_document}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            {teamId !== STATUS.APARTMENT && teamId !== STATUS.SUPPLY && (
              <div className="panel-card">
                <div className="panel-heading">{localization.parkingRules}</div>
                <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={localization.overnight}
                      data={
                        details.parking_rules?.overnight_parking_allowed &&
                        details.parking_rules?.overnight_parking_allowed !==
                          "undefined"
                          ? details.parking_rules.overnight_parking_allowed
                          : localization.na
                      }
                    />
                    <DivLayout
                      heading={localization.twowheelers}
                      data={
                        details.parking_rules?.two_wheeler_allowed_with_car &&
                        details.parking_rules?.two_wheeler_allowed_with_car !==
                          "undefined"
                          ? details.parking_rules.two_wheeler_allowed_with_car
                          : localization.na
                      }
                    />
                    <div className="details-list">
                      <strong className="data-title">
                        {localization.timings}
                      </strong>
                      <span className="data-details">
                        {details.parking_rules?.start_time &&
                        details.parking_rules?.start_time !== "undefined"
                          ? details.parking_rules.start_time
                          : localization.na}{" "}
                        -{" "}
                        {details.parking_rules?.end_time &&
                        details.parking_rules?.end_time !== "undefined"
                          ? details.parking_rules.end_time
                          : localization.na}
                      </span>
                    </div>
                    <DivLayout
                      heading={localization.anyOther}
                      data={
                        details.parking_rules?.other_rule &&
                        details.parking_rules?.other_rule !== "undefined"
                          ? details.parking_rules.other_rule
                          : localization.na
                      }
                    />
                    {teamId === STATUS.CORPORATE ||
                    teamId === STATUS.APARTMENT ? (
                      <DivLayout
                        heading={localization.marketingReq}
                        data={
                          details.marketing_requirement &&
                          details.marketing_requirement !== "undefined"
                            ? details.marketing_requirement
                            : localization.na
                        }
                      />
                    ) : null}
                    {teamId === STATUS.CORPORATE ? (
                      <DivLayout
                        heading={localization.expectedLive}
                        data={
                          details?.expected_live_date &&
                          details?.expected_live_date !== "undefined"
                            ? details.expected_live_date
                            : localization.na
                        }
                      />
                    ) : null}
                    {/* {teamId === STATUS.SUPPLY ? (
                    <Fragment>
                      <DivLayout
                        heading={localization.marketingSignageCount}
                        data={
                          details?.signage_requirements_number
                            ? details.signage_requirements_number
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.marketingSignageType}
                        data={
                          details?.signage_requirements_type
                            ? details.signage_requirements_type
                            : localization.na
                        }
                      />
                    </Fragment>
                  ) : null} */}
                  </div>
                </div>
              </div>
            )}

            <AddressView
              details={details?.bill_to}
              addressType={localization.billedTo}
            />
            <AddressView
              details={details?.ship_to}
              addressType={localization.shippedTo}
            />
            <div className="panel-card">
              <div className="panel-heading">{localization.otherDetail}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.portForwarding}
                    data={
                      details?.port_forwarding
                        ? details.port_forwarding
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.workTime}
                    data={
                      details?.working_timing
                        ? details.working_timing
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.remarks}
                    data={details?.remarks ? details.remarks : localization.na}
                  />
                  {teamId === 7 ? (
                    <DivLayout
                      heading={localization.isSEZ}
                      data={details?.is_sez ? details.is_sez : localization.na}
                    />
                  ) : null}
                  <DivLayout
                    heading={localization.scopeOfCivilWork}
                    data={
                      details?.scope_of_civil_work
                        ? details.scope_of_civil_work
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.po_woNumber}
                    data={
                      details?.contract_number
                        ? details.contract_number
                        : localization.na
                    }
                  />
                  {details?.contract_copy ? (
                    <DocumentView
                      title={localization.po_woCopy}
                      attachment={details?.contract_copy}
                    />
                  ) : null}

                  {details?.site_photo && details.site_photo.length > 0 && (
                    <h5>{localization.sitePhotos}</h5>
                  )}
                  {details?.site_photo &&
                    details.site_photo.length > 0 &&
                    details.site_photo.map((obj, index) => {
                      return (
                        <Fragment>
                          <DocumentView
                            title={`${localization.image} ${index + 1}`}
                            attachment={obj}
                          />
                        </Fragment>
                      );
                    })}

                  {details?.site_video && details.site_video.length > 0 && (
                    <h5>{localization.siteVideos}</h5>
                  )}

                  {details?.site_video &&
                    details.site_video.length > 0 &&
                    details.site_video.map((obj, index) => {
                      return (
                        <Fragment>
                          <DocumentView
                            title={`${localization.video} ${index + 1}`}
                            attachment={obj}
                          />
                        </Fragment>
                      );
                    })}
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </div>

      <div className="panel-card">
        <div className="panel-heading">{localization.clientDetails}</div>
        <div className="panel-body">
          <div className="details-listing">
            <DivLayout
              heading={localization.clientName}
              data={
                details.client?.client_name
                  ? details.client.client_name
                  : localization.na
              }
            />
            <DivLayout
              heading={localization.panNumber}
              data={
                details.client?.pan_number
                  ? details.client.pan_number
                  : localization.na
              }
            />
          </div>
          <hr />
          <div className="details-listing">
            <DivLayout
              heading={localization.POCName}
              data={
                details.client_leads_poc?.name
                  ? details.client_leads_poc.name
                  : localization.na
              }
            />
            <DivLayout
              heading={localization.designation}
              data={
                details.client_leads_poc?.designation
                  ? details.client_leads_poc.designation
                  : localization.na
              }
            />
            <DivLayout
              heading={localization.email}
              data={
                details.client_leads_poc?.email
                  ? details.client_leads_poc.email
                  : localization.na
              }
            />

            <DivLayout
              heading={localization.phoneNumber}
              data={
                details.client_leads_poc?.contact_no
                  ? details.client_leads_poc.contact_no
                  : localization.na
              }
            />
          </div>
        </div>
      </div>

      {clientBrd !== null && (
        <div className="panel-card">
          <div className="panel-heading">{localization.clientBrd}</div>
          <div className="panel-body">
            <DocumentView
              title={localization.clientBrd}
              attachment={clientBrd}
            />
          </div>
        </div>
      )}

      {/* invoice module START */}
      {details && details.invoice_module && details.invoice_module.length &&
      (!details.capex_invoicing_details ||
        (Array.isArray(details.capex_invoicing_details) && details.capex_invoicing_details.length == 0) ||
        (typeof details.capex_invoicing_details === 'object' &&
          !Array.isArray(details.capex_invoicing_details) &&
          Object.keys(details.capex_invoicing_details).length == 0)) ? (
        <div className="panel-card">
          <div className="panel-heading">{localization.invoiceModule}</div>
          <div className="panel-body">
            {details.invoice_module.map((obj, index) => {
              return (
                <div className="details-listing" key={index}>
                  <DivLayout heading={localization.product} data={obj.name} />
                  <DivLayout
                    heading={localization.amount}
                    data={obj.subscription_amount}
                  />
                  <DivLayout
                    heading={localization.details}
                    data={obj.description}
                  />

                  <hr />
                </div>
              );
            })}
          </div>
        </div>
      ) : null}

      {/* capex invoice module START */}
      {details?.capex_invoicing_details && 
                        typeof details?.capex_invoicing_details === 'object' && 
                        !Array.isArray(details?.capex_invoicing_details) && 
                        Object.keys(details?.capex_invoicing_details).length > 0 ? (
        <div className="panel-card">
          <div className="panel-heading">
            {localization.invoiceModule}
            { details?.capex_invoicing_details?.invoice_frequency_id == 1 &&
              <div className="float-right" style={{ marginTop: '-5px' }}>
                <button 
                  onClick={handleCapexInvoicePreview}
                  className="btn btn-sm btn-primary mr-2"
                  disabled={isLoadingPreview}
                  style={{ backgroundColor: '#ffffff', cursor: isLoadingPreview ? 'not-allowed' : 'pointer' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                >
                  {isLoadingPreview ? 'Generating...' : 'Invoice Preview'}
                </button>
                {details?.capex_invoicing_details?.meta_data?.pdf_link && (
                  <a 
                    href={details.capex_invoicing_details.meta_data.pdf_link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-success"
                  >
                    View Invoice
                  </a>
                )}
              </div>
            }
          </div>
          <div className="panel-body">
            <div className="details-listing">
              <DivLayout
                heading={localization.contractAmount}
                data={`₹ ${parseFloat(details?.capex_invoicing_details?.total_amount ? details?.capex_invoicing_details?.total_amount : 0).toFixed(2)}`}
              />
              <hr/>
              <DivLayout
                heading={localization.hardwareAmount}
                data={
                  <span>
                    ₹ {(parseFloat(details?.commercial?.hardware_amount || 0) + parseFloat(details?.commercial?.software_amount || 0)).toFixed(2)}
                    <span className="info-icon-container">
                      <span className="info-icon">i</span>
                      <div className="info-tooltip">
                        <div className="tooltip-title">Breakdown:</div>
                        <div className="tooltip-item">Hardware: ₹{parseFloat(details?.commercial?.hardware_amount || 0).toFixed(2)}</div>
                        <div className="tooltip-item">Software: ₹{parseFloat(details?.commercial?.software_amount || 0).toFixed(2)}</div>
                      </div>
                    </span>
                  </span>
                }
              />
              <DivLayout
                heading={localization.cartage}
                data={`₹ ${parseFloat(details?.commercial?.cartage_amount ? details?.commercial?.cartage_amount : 0).toFixed(2)}`}
              />
              <DivLayout
                heading={localization.capexIntstallationAmount}
                data={
                  <span>
                    ₹ {parseFloat(details?.commercial?.installation_amount ? details?.commercial?.installation_amount : 0).toFixed(2)}
                    <span className="info-icon-container">
                      <span className="info-icon">i</span>
                      <div className="info-tooltip">
                        <div className="tooltip-title">Breakdown:</div>
                        <div className="tooltip-item">Labour: ₹{parseFloat(details?.commercial?.labour_amount || 0).toFixed(2)}</div>
                        <div className="tooltip-item">Consumables: ₹{parseFloat(details?.commercial?.consumable_amount || 0).toFixed(2)}</div>
                      </div>
                    </span>
                  </span>
                }
              />
              <DivLayout
                heading={localization.tagsAmount}
                data={`₹ ${parseFloat(details?.commercial?.tags_amount ? details?.commercial?.tags_amount : 0).toFixed(2)}`}
              />
              <hr />
            </div>
            <div className="details-listing">
              <DivLayout
                heading={localization.invoiceFrequency}
                data={details.capex_invoicing_details?.invoice_frequency_value}
              />
              {details.capex_invoicing_details?.invoice_frequency_id == 1 
              ?
              <>
                <DivLayout
                  heading={localization.hardwareFrequency}
                  data={details.capex_invoicing_details?.invoice_nomenclature_value}
                />
                <DivLayout
                  heading={localization.consumbaleFrequency}
                  data={details.capex_invoicing_details?.invoice_consumable_boq_value}
                />
              </>
              :
              <>
                <DivLayout
                  heading={localization.raBills}
                  data={details.capex_invoicing_details.is_ra_bills == 'yes' ? 'Yes' : 'No'}
                />
              </>
              }
              
              <hr />
            </div>
            {details.capex_invoicing_details?.invoices_items && details.capex_invoicing_details.invoices_items.length > 0 && (
              details.capex_invoicing_details?.invoice_frequency_id == 1 ? 
              <>
                <div className="details-listing">
                  <div className="w-100">
                    {details.capex_invoicing_details.invoices_items.map((invoice, index) => (
                      <div key={index} className="card mb-2">
                        <div 
                          className="card-header" 
                          style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                          onClick={() => toggleAccordion('invoice', index)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <span># {localization.invoiceNo} {index + 1}</span>
                            <span>{isAccordionOpen('invoice', index) ? '−' : '+'}</span>
                          </div>
                        </div>
                        {isAccordionOpen('invoice', index) && (
                          <div className="card-body">
                            {renderSingleInvoiceItems(invoice)}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </>
              :
              details.capex_invoicing_details.invoices_items.map((invoice, index) => (
                <Fragment key={index}>
                  <div className="details-listing">
                    <div className="w-100">
                      <div className="card mb-2">
                        <div 
                          className="card-header" 
                          style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                          onClick={() => toggleAccordion('invoice-milestone', index)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <span># {localization.milestoneNo} {index + 1}</span>
                            <span>{isAccordionOpen('invoice-milestone', index) ? '−' : '+'}</span>
                          </div>
                        </div>
                        {isAccordionOpen('invoice-milestone', index) && (
                          <div className="card-body">
                            {renderMileStoneInvoiceItems(invoice)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {details.milestone?.retention && details.milestone?.retention.length > 0 && (
                    <div className="details-listing">
                      <div className="w-100">
                        <div className="card mb-2">
                          <div 
                            className="card-header" 
                            style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                            onClick={() => toggleAccordion('invoice-retention', index)}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <span># {localization.retentionInvoice}</span>
                              <span>{isAccordionOpen('invoice-retention', index) ? '−' : '+'}</span>
                            </div>
                          </div>
                          {isAccordionOpen('invoice-retention', index) && (
                            <div className="card-body">
                              {renderRetentionInvoiceItems(details.milestone?.retention)}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </Fragment>
              ))
            )}
            { details?.capex_invoicing_details?.meta_data && 
                        typeof details?.capex_invoicing_details?.meta_data === 'object' && 
                        !Array.isArray(details?.capex_invoicing_details?.meta_data) && 
                        Object.keys(details?.capex_invoicing_details?.meta_data).length > 0 && (
              <>
                <hr />
                <div className="details-listing">
                  <DivLayout
                    heading={`${details.capex_invoicing_details.meta_data.invoice_type === 'PI' 
                      ? details.capex_invoicing_details.meta_data.invoice_type 
                      : `Advance ${details.capex_invoicing_details.meta_data.invoice_type}`} No.`}
                    data={details.capex_invoicing_details.meta_data.invoice_number}
                  />
                  <DocumentView
                    title={`${details.capex_invoicing_details.meta_data.invoice_type === 'PI' 
                      ? details.capex_invoicing_details.meta_data.invoice_type 
                      : `Advance ${details.capex_invoicing_details.meta_data.invoice_type}`} link`}                    
                    attachment={details.capex_invoicing_details.meta_data.pdf_link}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      ) : null}

      {/* TAG END */}
      {details && details.leadAdvPayment && details.leadAdvPayment.length ? (
        <div className="panel-card">
          <div className="panel-heading">{localization.advancePayment}</div>
          <div className="panel-body">
            {details.leadAdvPayment.map((obj, index) => {
              return (
                <div className="details-listing" key={index}>
                  <DivLayout
                    heading={localization.installmentAmt}
                    data={obj.installation_amt}
                  />
                  <DivLayout
                    heading={localization.rentalCharge}
                    data={obj.rental_charge}
                  />
                  <DivLayout
                    heading={localization.tagCharge}
                    data={obj.tag_charge}
                  />
                  <DivLayout
                    heading={localization.capexCharge}
                    data={obj.capex_charge}
                  />
                  <DivLayout
                    heading={localization.cartage_amount}
                    data={obj.cartage_amt}
                  />
                  <DivLayout
                    heading={localization.amount}
                    data={obj.adv_amount}
                  />
                  <DivLayout
                    heading={localization.referenceNumber}
                    data={obj.reference_number}
                  />
                  {obj.tds_amt > 0 ? (
                    <DivLayout
                      heading={localization.tdsAmount}
                      data={obj.tds_amt}
                    />
                  ) : (
                    <DivLayout
                      heading={localization.tdsAmount}
                      data={obj.tds_check}
                    />
                  )}
                  <DivLayout
                    heading={localization.paymentMode}
                    data={obj.payment_mode}
                  />
                  <DivLayout heading={localization.status} data={obj.status} />
                  <DivLayout
                    heading={localization.paymentDate}
                    data={obj.adv_payment_date}
                  />
                  <DivLayout heading={localization.remarks} data={obj.remark} />
                  {obj.payment_photos ? (
                    <>
                      {Array.isArray(obj.payment_photos) ? (
                        obj.payment_photos.map((val, i) => (
                          <DocumentView
                            key={i}
                            title={localization.referenceDocument}
                            attachment={val}
                          />
                        ))
                      ) : (
                        <DocumentView
                          title={localization.referenceDocument}
                          attachment={obj.payment_photos}
                        />
                      )}
                    </>
                  ) : null}
                  <hr />
                </div>
              );
            })}
          </div>
        </div>
      ) : null}

      <div className="panel-card">
        <div className="panel-heading">{localization.increament}</div>
        <div className="panel-body">
          <div className="details-listing">
            <DivLayout
              heading={localization.typeIncreament}
              data={
                details?.increment_type
                  ? details.increment_type
                  : localization.na
              }
            />
            {details.increment_type &&
            details.increment_type != "nonUniform" ? (
              <>
                <DivLayout
                  heading={localization.increamentAmount}
                  data={
                    details?.increament_amount
                      ? details.increament_amount
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.duration}
                  data={details?.duration ? details.duration : localization.na}
                />
              </>
            ) : null}
            <hr />

            {details.inc &&
              details.inc.map((obj, index) => {
                return (
                  <div className="details-listing" key={index}>
                    <DivLayout
                      heading={
                        localization.installmentAmt + " " + obj.installment
                      }
                      data={obj.subscription_amount}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {modificationData && modificationData.length > 0 && (
        <>
          {modificationData.map((modification, index) => (
            <div key={index} className="panel-card">
              <div className="panel-heading">{`Modification Details ${index + 1}`}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={'Requestor Name'}
                    data={modification?.requested_by_name}
                  />
                  <DivLayout
                    heading={'Requestor Email'}
                    data={modification?.requested_by_email}
                  />
                  <DivLayout
                    heading={'Remark'}
                    data={modification?.remark}
                  />
                  <DivLayout
                    heading={'Modifier Name'}
                    data={modification?.modified_by_name || localization.na}
                  />
                  <DivLayout
                    heading={'Modifier Email'}
                    data={modification?.modified_by_email || localization.na}
                  />
                  <DivLayout
                    heading={'Modification Date'}
                    data={modification?.modified_at || localization.na}
                  />
                  <DocumentView
                    attachment={modification?.attachment}
                    title={"Attachment"}
                  />
                </div>
              </div>
            </div>
          ))}
        </>
      )}



      {details &&
        details.material_hardware &&
        details.material_hardware.category &&
        details.material_hardware.category.length > 0 && (
          <InventoryDetail
            key="category-inventory"
            heading={localization.categoryInventory}
            details={details.material_hardware.category}
            inventoryType={localization.cat}
          />
        )}

      {details &&
        details.material_hardware &&
        details.material_hardware.material &&
        details.material_hardware.material.length > 0 && (
          <InventoryDetail
            key="product-inventory"
            heading={localization.productInventory}
            details={details.material_hardware.material}
            inventoryType={localization.product}
          />
        )}

      {details?.software && details.software.length > 0 && (
        <SoftwareInventoryDetail
          key="software-inventory"
          heading={localization.softwareInventory}
          details={details.software}
        />
      )}

      {details?.lead_tags && details.lead_tags.length > 0 && (
        <TagsInventoryDetail
          key="lead-tags-inventory"
          heading={localization.tags}
          details={details.lead_tags}
        />
      )}

      {teamId === STATUS.B2BALLIANCE && (
        <Fragment>
          <div className="panel-card">
            <div className="panel-heading">{localization.otherDetail}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={localization.newFeature}
                  data={
                    details?.new_feature_required
                      ? details.new_feature_required
                      : localization.na
                  }
                />
                {details?.new_feature_required === "Yes" && (
                  <DivLayout
                    heading={localization.featureDesc}
                    data={
                      details?.new_feature_description
                        ? details.new_feature_description
                        : localization.na
                    }
                  />
                )}
                {details?.partner_marketing_commitment && (
                  <DivLayout
                    heading={localization.partnerParketingCommitment}
                    data={
                      details?.partner_marketing_commitment
                        ? details.partner_marketing_commitment
                        : localization.na
                    }
                  />
                )}
                {details?.park_marketing_commitment && (
                  <DivLayout
                    heading={localization.parkMarketingCommitment}
                    data={
                      details?.park_marketing_commitment
                        ? details.park_marketing_commitment
                        : localization.na
                    }
                  />
                )}

                <DivLayout
                  heading={localization.paymentTerms}
                  data={
                    details?.payment_terms
                      ? details.payment_terms
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.vehicleType}
                  data={
                    details?.vehicle_type
                      ? details.vehicle_type
                      : localization.na
                  }
                />
                {details?.partner_logo && (
                  <DocumentView
                    title={localization.partnerLogo}
                    attachment={details?.partner_logo}
                  />
                )}
                {details?.agreement_doc && (
                  <DocumentView
                    title={localization.attachmentAgreement}
                    attachment={details?.agreement_doc}
                  />
                )}
              </div>
            </div>
          </div>

          {details?.operation_team_data && (
            <div className="panel-card">
              <div className="panel-heading">{localization.operationTeam}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.deliveryDate}
                    data={
                      details?.operation_team_data?.delivery_date
                        ? details?.operation_team_data?.delivery_date
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.partnerDate}
                    data={
                      details?.operation_team_data?.partner_desired_date
                        ? details?.operation_team_data?.partner_desired_date
                        : localization.na
                    }
                  />
                </div>
              </div>
              <div className="panel-heading full-width">
                {localization.escalContact}
              </div>
              <div className="panel-body">
                {details?.operation_team_data?.escalation_contact &&
                  details?.operation_team_data?.escalation_contact.map(
                    (val, index) => (
                      <div className="details-listing" key={index + 1}>
                        <DivLayout
                          heading={localization.name}
                          data={val?.name ? val.name : localization.na}
                        />
                        <DivLayout
                          heading={localization.contact}
                          data={val?.contact ? val.contact : localization.na}
                        />
                      </div>
                    )
                  )}
              </div>
              <div className="panel-heading full-width">{localization.poc}</div>
              <div className="panel-body">
                {details?.operation_team_data?.poc &&
                  details?.operation_team_data?.poc.map((val, index) => (
                    <div className="details-listing" key={index + 1}>
                      <DivLayout
                        heading={localization.name}
                        data={val?.name ? val.name : localization.na}
                      />
                      <DivLayout
                        heading={localization.contact}
                        data={val?.contact ? val.contact : localization.na}
                      />
                    </div>
                  ))}
              </div>
            </div>
          )}
          {details?.product_team_data && (
            <div className="panel-card">
              <div className="panel-heading">{localization.productTeam}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.deliveryDate}
                    data={
                      details?.product_team_data?.delivery_date
                        ? details?.product_team_data?.delivery_date
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.partnerDate}
                    data={
                      details?.product_team_data?.partner_desired_date
                        ? details?.product_team_data?.partner_desired_date
                        : localization.na
                    }
                  />
                </div>
              </div>
              <div className="panel-heading full-width">
                {localization.escalContact}
              </div>
              <div className="panel-body">
                {details?.product_team_data?.escalation_contact &&
                  details?.product_team_data?.escalation_contact.map(
                    (val, index) => (
                      <div className="details-listing" key={index + 1}>
                        <DivLayout
                          heading={localization.name}
                          data={val?.name ? val.name : localization.na}
                        />
                        <DivLayout
                          heading={localization.contact}
                          data={val?.contact ? val.contact : localization.na}
                        />
                      </div>
                    )
                  )}
              </div>
              <div className="panel-heading full-width">{localization.poc}</div>
              <div className="panel-body">
                {details?.product_team_data?.poc &&
                  details?.product_team_data?.poc.map((val, index) => (
                    <div className="details-listing" key={index + 1}>
                      <DivLayout
                        heading={localization.name}
                        data={val?.name ? val.name : localization.na}
                      />
                      <DivLayout
                        heading={localization.contact}
                        data={val?.contact ? val.contact : localization.na}
                      />
                    </div>
                  ))}
              </div>
            </div>
          )}
          {details?.supply_team_data && (
            <div className="panel-card">
              <div className="panel-heading">{localization.supplyTeam}</div>
              <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                    heading={localization.deliveryDate}
                    data={
                      details?.supply_team_data?.delivery_date
                        ? details?.supply_team_data?.delivery_date
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.partnerDate}
                    data={
                      details?.supply_team_data?.partner_desired_date
                        ? details?.supply_team_data?.partner_desired_date
                        : localization.na
                    }
                  />
                </div>
              </div>
              <div className="panel-heading full-width">
                {localization.escalContact}
              </div>
              <div className="panel-body">
                {details?.supply_team_data?.escalation_contact &&
                  details?.supply_team_data?.escalation_contact.map(
                    (val, index) => (
                      <div className="details-listing" key={index + 1}>
                        <DivLayout
                          heading={localization.name}
                          data={val?.name ? val.name : localization.na}
                        />
                        <DivLayout
                          heading={localization.contact}
                          data={val?.contact ? val.contact : localization.na}
                        />
                      </div>
                    )
                  )}
              </div>
              <div className="panel-heading full-width">{localization.poc}</div>
              <div className="panel-body">
                {details?.supply_team_data?.poc &&
                  details?.supply_team_data?.poc.map((val, index) => (
                    <div className="details-listing" key={index + 1}>
                      <DivLayout
                        heading={localization.name}
                        data={val?.name ? val.name : localization.na}
                      />
                      <DivLayout
                        heading={localization.contact}
                        data={val?.contact ? val.contact : localization.na}
                      />
                    </div>
                  ))}
              </div>
            </div>
          )}
        </Fragment>
      )}
      {requiredDocuments && requiredDocuments?.length > 0 && (
        <div className="panel-card">
          <div className="panel-heading">{'Required Documents'}</div>
          <div className="panel-body">
            {requiredDocuments.map((document, index) => (
              <DocumentView
                key={index}
                title={document.description} 
                attachment={document.url}  
              />
            ))}
          </div>
        </div>
      )}
      {details?.required_documents_list && details?.required_documents_list?.length > 0 && (
        <div className="panel-card">
          <div className="panel-heading">{'Sales Required Documents'}</div>
          <div className="panel-body">
            <div className="details-listing">
              <div className="card">
                {details?.required_documents_list.map((document, index) => (
                  <div className="card-body" key={index}>{document}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Capex Invoice Preview Modal */}
      <ModalPop
        title={'Invoices Preview'}
        show={isModalPreview}
        handleModalHide={handlePreviewModalHide}
        keyboard
        backdrop
      >
        <>
          <div className="pdf-preview-container">
            {capexInvoicePreviewLinks.map((invoiceLink, index) => (
              <iframe
                key={index}
                src={`${invoiceLink}#toolbar=0`}
                title={`Invoice PDF ${index + 1}`}
                width="100%"
                height="700px"
                style={{ border: "none", marginBottom: "1rem" }}
              />
            ))}
          </div>
        </>
      </ModalPop>
    </Fragment>
  );
};

export default PostsaleView;
